<template>
    <div>
        <b-modal
            :id="modalId"
            modal-class="modal-confirm-redeem"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline" v-html="headline"></p>
                </div>
                <div class="modal-base-body">
                    <BuyConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'buy'" />
                    <DefaultConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'default'" />
                    <DeliveryConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'delivery'" />
                    <DrawConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'draw'" />
                    <InterfaceConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'interface'" />
                </div>
                <div class="modal-base-footer">
                    <TwoButtonRow
                       secondaryBtnId="cancel_redeem_btn"
                       :secondaryBtnMsg="lbl.confirm_redeem.cancel"
                       @clickSecondaryBtn="cancel"
                       primaryBtnId="confirm_redeem_btn"
                       :primaryBtnMsg="lbl.confirm_redeem.confirm"
                       @clickPrimaryBtn="confirm" />
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
//helper
import Locale from '@/helper/locale/Locale.js';
//component confirm redeem
import BuyConfirmRedeem from './Component/BuyConfirmRedeem.vue';
import DefaultConfirmRedeem from './Component/DefaultConfirmRedeem.vue';
import DeliveryConfirmRedeem from './Component/DeliveryConfirmRedeem.vue';
import DrawConfirmRedeem from './Component/DrawConfirmRedeem.vue';
import InterfaceConfirmRedeem from './Component/InterfaceConfirmRedeem.vue';
//component button
import TwoButtonRow from '@/components/Button/TwoButtonRow.vue';
export default {
    name: 'ConfirmRedeemModal',
    components: {
        //confirm redeem
        BuyConfirmRedeem,
        DefaultConfirmRedeem,
        DeliveryConfirmRedeem,
        DrawConfirmRedeem,
        InterfaceConfirmRedeem,
        //button
        TwoButtonRow
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            headline: '',
            type: '',
            //config
            campaign: null,
            tag: null,

            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        confirm: function () {
            this.hide();
            this.controller.eventClickConfirm({tag: this.tag})
        },
        cancel: function () {
            this.hide();
            this.controller.eventClickCancel({tag: this.tag});
        },
        //initial
        initialModal: function () {
            if (!this.campaign.delivered) {
                switch (this.campaign.type) {
                    case Vue.CampaignType.Buy:
                        this.type = 'buy';
                        break;
                    case Vue.CampaignType.Draw:
                        this.type = 'draw';
                        break;
                    case Vue.CampaignType.Interface:
                        this.type = 'interface';
                        break;
                    case Vue.CampaignType.Free:
                    case Vue.CampaignType.Deal:
                        this.type = 'default';
                        break;
                }
            } else {
                this.type = 'delivery';
            }

            this.$bvModal.show(this.modalId);
        },
        //modal
        show: function (config) {
            this.campaign = config.campaign;
            this.tag = config.tag;

            this.initialModal();
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";
</style>
